import React, { PropTypes } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Well, Button } from 'react-bootstrap';
import renderField from '../../FormTemplate/InputControl';

class NewCategoryForm extends React.Component {

   constructor(props) {
      super(props);
      this.newCategoryCreate = this.newCategoryCreate.bind(this);
   }

   newCategoryCreate(inputs) {
      return this.props.createNewCategory(inputs, this.props.shopId);
   }

   render() {
      const { handleSubmit } = this.props; //eslint-disable-line react/prop-types
      return (<Well>
            <form noValidate autoComplete="off" onSubmit={handleSubmit(this.newCategoryCreate)} >
               <Field name="name" component={renderField} type="text" placeholder="Category Name"
                      label="Category Name" />
               <Button type="submit" >Save</Button>
            </form>
         </Well>
      );
   }
}

NewCategoryForm.propTypes = {
   createNewCategory: PropTypes.func.isRequired,
   shopId: PropTypes.number.isRequired
};

export default reduxForm({
   form: 'newCategoryForm'
})(NewCategoryForm);



/** WEBPACK FOOTER **
 ** ./src/components/ShopManagement/Shop/NewCategoryForm.js
 **/